import {UserGroup} from '@core/api/data-access';

export type IStateUserGroup = {
	id: string;
	group?: UserGroup;
	loadingState?: 'loading' | 'success' | 'error';
};

export type IUserGroupsGlobalState = {
	loading: boolean;
	loaded: boolean;
	lastUpdate: Date | null;
};

export const userGroupsGlobalInitialState: IUserGroupsGlobalState = {
	loading: false,
	loaded: false,
	lastUpdate: null,
};

export type IQueryUserGroupsResponse = {
	totalGroups: number;
	fromGroup: number;
	toGroup: number;
	groups: UserGroup[];
};
